import React, { useEffect } from 'react';
import { expValEquals } from '@atlassian/jira-feature-experiments';
import { useFlagsService } from '@atlassian/jira-flags';
import NonCritical from '@atlassian/jira-non-critical';
import { useHasSeenIt } from '@atlassian/jira-onboarding-core/src/services/has-seen-it';
import { useOrgId } from '@atlassian/jira-router-resources-navigation-org-id';
import { DES_SHARE_LINK_FLAG_ID, useShareDesLinkFlag } from '../hooks';
import { checkIsDesEnabled } from '../services';
import { useIsEligibleForDesShareLinkExperiment } from '../utils/is-eligible-for-experiment';

export const DesShareLinkFlag = () => {
	const { showShareLinkThroughDesFlag } = useShareDesLinkFlag();
	const { data: orgId } = useOrgId();
	const isEligible = useIsEligibleForDesShareLinkExperiment();
	const [hasInteractedWithDesShareLinkFlag] = useHasSeenIt({
		hasSeenItKey: 'desShareLinkFlag',
		skipFetch: !isEligible,
	});
	const { hasFlag } = useFlagsService();

	useEffect(() => {
		let ignoreResult = false;

		const checkEligibilityAndShowFlagIfInVariation = async () => {
			if (hasFlag && hasFlag(DES_SHARE_LINK_FLAG_ID)) {
				return;
			}

			if (
				isEligible &&
				hasInteractedWithDesShareLinkFlag?.fetchStatus === 'fetched' &&
				hasInteractedWithDesShareLinkFlag.value === false
			) {
				const { isDesEnabled, domain } = await checkIsDesEnabled(orgId);
				if (!ignoreResult && isDesEnabled && domain) {
					if (expValEquals('jira_des_link_share', 'isEnabled', true)) {
						showShareLinkThroughDesFlag(domain);
					}
				}
			}
		};

		checkEligibilityAndShowFlagIfInVariation();

		return () => {
			ignoreResult = true;
		};
	}, [orgId, showShareLinkThroughDesFlag, hasInteractedWithDesShareLinkFlag, isEligible, hasFlag]);

	return null;
};

export const NonCriticalDesShareLinkFlag = () => (
	<NonCritical teamName="Jlove-Makkuro" id="non-critical-jira-des-share-link">
		<DesShareLinkFlag />
	</NonCritical>
);
